import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCommon from '@rci/state-common-reducer';
import { featureName } from '@rci/state-common-reducer';
import { Language, Province } from '@rci/state-common-actions';

export interface State {
  [featureName]: fromCommon.CommonState;
}

// Selector functions
const getCommonFeatureState = createFeatureSelector<fromCommon.CommonState>(featureName);

export const getLanguage = createSelector(getCommonFeatureState, state => state?.language);

export const getProvince = createSelector(getCommonFeatureState, state => state?.province);

export const getUserLoginState = createSelector(getCommonFeatureState, state => state?.userLoginState);

export const getLanguageAndProvince = createSelector(
  getLanguage,
  getProvince,
  (lang, prov) => [lang, prov] as [Language, Province],
);
